import React, { useState, useRef, useEffect } from "react";
import "./style.scss";

interface DropdownItem {
  id: string | number;
  label: string;
  value: any;
}

interface PopoverDropdownProps {
  title: string;
  items: DropdownItem[];
  onSelect: (item: DropdownItem) => void;
  className?: string;
  triggerClassName?: string;
  popoverClassName?: string;
}

export const PopoverDropdown: React.FC<PopoverDropdownProps> = ({
  title,
  items,
  onSelect,
  className = "",
  triggerClassName = "",
  popoverClassName = "",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleItemClick = (item: DropdownItem) => {
    onSelect(item);
    setIsOpen(false);
  };

  return (
    <div className={`popover-dropdown ${className}`} ref={dropdownRef}>
      <div
        className={`popover-trigger ${triggerClassName} ${
          isOpen ? "active" : ""
        }`}
        onClick={toggleDropdown}
      >
        {title}
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={`chevron ${isOpen ? "open" : ""}`}
        >
          <path d="m6 9 6 6 6-6" />
        </svg>
      </div>

      {isOpen && (
        <div className={`popover-content ${popoverClassName}`}>
          <ul className="dropdown-list">
            {items.map(item => (
              <li
                key={item.id}
                className="dropdown-item"
                onClick={() => handleItemClick(item)}
              >
                {item.label}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default PopoverDropdown;
